var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "newPopover",
    {
      ref: "newPopover",
      attrs: { title: _vm.form.id ? "修改游戏" : "新增游戏" },
      on: {
        dlodingHide: function($event) {
          return _vm.clearData("")
        },
        clearData: function($event) {
          return _vm.clearData(_vm.form.id)
        },
        submitData: _vm.submitData
      }
    },
    [
      _c(
        "div",
        { attrs: { slot: "content" }, slot: "content" },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "110px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "游戏名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入游戏名称" },
                    model: {
                      value: _vm.form.name,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "游戏类型", prop: "game_type_id" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", clearable: "" },
                      model: {
                        value: _vm.form.game_type_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "game_type_id", $$v)
                        },
                        expression: "form.game_type_id"
                      }
                    },
                    _vm._l(_vm.gameTypeList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "跳转链接", prop: "link" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入跳转链接" },
                    model: {
                      value: _vm.form.link,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "link", $$v)
                      },
                      expression: "form.link"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "描述", prop: "desc" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入描述" },
                    model: {
                      value: _vm.form.desc,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "desc", $$v)
                      },
                      expression: "form.desc"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "游戏图标", prop: "icon" } },
                [
                  _c("uploadImage", {
                    ref: "iconUploadImage",
                    attrs: { limit: 1, "file-list": _vm.iconfileList },
                    on: {
                      change: function($event) {
                        return _vm.iconUrl($event)
                      },
                      delUrl: function($event) {
                        return _vm.delUrl($event)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "游戏宣传图", prop: "pic" } },
                [
                  _c("uploadImage", {
                    ref: "picUploadImage",
                    attrs: { limit: 1, "file-list": _vm.picfileList },
                    on: {
                      change: function($event) {
                        return _vm.picUrl($event)
                      },
                      delUrl: function($event) {
                        return _vm.delUrl($event)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.status,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1, border: "" } }, [
                        _vm._v("启用")
                      ]),
                      _c("el-radio", { attrs: { label: 2, border: "" } }, [
                        _vm._v("禁用")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }